import React, { Component } from 'react';

export default class QuantityPicker extends Component {

  constructor(props) {
    super(props);

    this.state = {value: this.props.value, disableDec: this.props.value === 0 ? true : false, disableInc: this.props.value === Number(this.props.max) ? true : false}
    this.increment = this.increment.bind(this);
    this.decrement = this.decrement.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  increment() {
    const plusState = this.state.value + 1;
    if (this.state.value < this.props.max){
      this.setState({value: plusState});
      this.handleChange(plusState);
      this.setState({disable: false});
    }
    if (this.state.value === (this.props.max - 1) || this.state.value === Number(this.props.max)) {
      this.setState({disableInc: true});
    }
    if (this.state.value === this.props.min) {
      this.setState({disableDec: false});
    }
  }

  decrement() {
    const minusState = this.state.value - 1;
    if (this.state.value > this.props.min) {
      this.setState({value: minusState });
      this.handleChange(minusState);
      if (this.state.value === this.props.min + 1) {
        this.setState({disableDec: true});
      }
    } else {
      this.setState({value: this.props.min});
      this.handleChange(this.props.min);
    }
    if (this.state.value === Number(this.props.max)) {
      this.setState({disableInc: false});
    }
  }

  handleChange(value) {
    this.props.onChange(value, this.state.value, this.props.max);
  }

  render() {
    const { disableDec, disableInc } = this.state;

    return (
      <span className="quantity-picker">
        <button className={`quantity-modifier modifier-left`} onClick={this.decrement} disabled={disableDec}>
          <span className='picker-icon minus-icon'></span>
        </button>
        <input className="quantity-display" type="text" value={this.state.value} readOnly />
        <button className={`quantity-modifier modifier-right`} onClick={this.increment} disabled={disableInc}>
          <span className='picker-icon plus-icon'></span>
        </button>
      </span>
    );
  }
}
